import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StickyNote, Loader2, Plus } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) : "");

export const MyNotesCard = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/me/notes").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  const recent = (items || []).slice(0, 4);

  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="my-notes-card">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">
            <StickyNote className="w-4 h-4 text-amber-500" /> My Notes
          </h2>
          <p className="text-xs text-slate-500 mt-0.5 mb-3">{(items || []).length} note{(items || []).length === 1 ? "" : "s"} · private to you</p>
        </div>
        <Link to="/me/notes" data-testid="my-notes-new" className="shrink-0 inline-flex items-center gap-1 text-xs font-semibold text-indigo-600 hover:text-indigo-700">
          <Plus className="w-3.5 h-3.5" /> New
        </Link>
      </div>

      {items === null ? (
        <div className="flex items-center gap-2 text-slate-400 text-sm py-4"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : recent.length === 0 ? (
        <div className="py-6 text-center text-sm text-slate-400" data-testid="my-notes-empty">No notes yet — jot something down.</div>
      ) : (
        <div className="space-y-2" data-testid="my-notes-list">
          {recent.map((n) => (
            <Link key={n.id} to="/me/notes" data-testid={`my-note-${n.id}`}
              className="block rounded-xl border border-slate-100 bg-slate-50/60 px-3 py-2 hover:bg-slate-50 transition-colors">
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-slate-800 text-sm truncate">{n.title || "Untitled note"}</span>
                <span className="text-[10px] text-slate-400 shrink-0">{fmt(n.updated_at)}</span>
              </div>
              {n.body && <p className="text-xs text-slate-500 mt-0.5 line-clamp-2 whitespace-pre-wrap">{n.body}</p>}
            </Link>
          ))}
        </div>
      )}

      <Link to="/me/notes" data-testid="my-notes-view-all" className="inline-block mt-4 text-sm font-semibold text-indigo-600 hover:text-indigo-700">Open My Notes →</Link>
    </div>
  );
};
